<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockSelected"
    :clearable="!unclearable"
    :items="stocksItems"
    :loading="stockLoading"
    :search-input.sync="stockSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Stock.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStock",

  props: {
    value: Object,
    stockDistrict: Object,
    stockDistricts: Array,
    noLabel: Boolean,
    label: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    types: Array,
    status: Array,
    stockIds: Array,
    selfPurchaseFlg: [Boolean, Number],
  },

  computed: {
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
          (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      if (this.stockDistricts && this.stockDistricts.length > 0) {
        stocks = this.stocks.filter((e) =>
          this.stockDistricts.find((v) => v.code == e.stock_district_code)
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == stock.id
            )
          : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
  },

  data: () => ({
    stocks: [],
    stockLoading: false,
    stockSearch: "",
    stockSelected: null,
  }),

  mounted() {
    this.stockLoading = true;
    var data = {
      types: this.types ? this.types : [],
    };
    if (this.status && this.status.length) {
      data = Object.assign({}, data, { status: this.status });
    }
    if (this.stockIds && this.stockIds.length) {
      data = Object.assign({}, data, { stock_ids: this.stockIds });
    }else {
      if (this.selfPurchaseFlg && this.selfPurchaseFlg == 1) {
        data = Object.assign({}, data, { stock_ids: [-1] });
      }
    }
    Stocks.fetchAllForSelect(data)
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
            if (this.$route.query.stock_id) {
              let result = this.stocks.filter((v) => {
                return v.id == this.$route.query.stock_id;
              });
              this.stockSelected = result[0];
            } else {
              if (!this.value && this.unclearable) {
                this.stockSelected = this.stocks[0];
              }
            }
          }
          this.stockLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.stockLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.unclearable && !this.value && this.stocks) {
          this.stockSelected = this.stocks[0];
        } else {
          this.stockSelected = this.value;
        }
      },
    },

    stockSelected: {
      handler() {
        this.$emit("input", this.stockSelected);
      },
    },
  },
};
</script>